/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2023-10-31 11:41:33
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-11-04 15:43:12
 * @FilePath: \合联\oms\src\api\finance\billingRecord.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios, { buildApi } from '@/libs/api.request';
let name = '/finance/invoice/record'

export const apis = buildApi({
  get: [name + '/index&list',],
  post: [name + '/setInvoicedOut', name + '/delete/:id&del']
})